import React from 'react'

// form fields
import AppFormikInput from 'utlis/helpers/forms/AppFormikInput'

export default function WeightAndDimensions(props) {
    // props
    const {
        formik
    } = props


    return (
        <React.Fragment>
            {/* page border box 2 */}
            <div className="page-border-box2">
                <div className="pbb2-inner">
                    {/* heading */}
                    <p className="box-heading st-fs-18 st-fw-600 st-text-color mb-2">Weight and Dimensions</p>

                    <p className="st-fs-13 st-text-color2">
                        Specify product's weight and dimensions to obtain precise carrier-calculated shipping rated for your customers.
                        To determine the right dimensions measure your product as if it were in a regular rectangular box.
                        To change unit system visit <a href="#" className="hover-underline-link st-text-primary">Regional Settings</a>
                    </p>

                    <div className="product-details-form-in-tax-and-shipping pt-3">
                        <div className="d-flex inner">
                            {/* form field */}
                            <div className="item media-body">
                                <AppFormikInput
                                    inputType={"number"}
                                    formik={formik} // formik object
                                    stFormClass={"weight-field no-arrows mb-0"} // class name for main wrapper
                                    labelName={"Weight (in lbs)"} // label name
                                    // isRequired={true} // is this field is required or not to show the red star sign
                                    placeholder={"Weight (in lbs)"} // placeholder for the input
                                    formikFieldName={"blogTitle"} // important: formik value name for the input
                                />
                            </div>

                            {/* form field */}
                            <div className="item">
                                <AppFormikInput
                                    inputType={"number"}
                                    formik={formik} // formik object
                                    stFormClass={"length-field no-arrows mb-0"} // class name for main wrapper
                                    labelName={"Length, in"} // label name
                                    // isRequired={true} // is this field is required or not to show the red star sign
                                    placeholder={"Length, in"} // placeholder for the input
                                    formikFieldName={"blogTitle"} // important: formik value name for the input
                                />
                            </div>

                            {/* form field */}
                            <div className="item">
                                <AppFormikInput
                                    inputType={"number"}
                                    formik={formik} // formik object
                                    stFormClass={"width-field no-arrows mb-0"} // class name for main wrapper
                                    labelName={"Width, in"} // label name
                                    // isRequired={true} // is this field is required or not to show the red star sign
                                    placeholder={"Width, in"} // placeholder for the input
                                    formikFieldName={"blogTitle"} // important: formik value name for the input
                                />
                            </div>

                            {/* form field */}
                            <div className="item">
                                <AppFormikInput
                                    inputType={"number"}
                                    formik={formik} // formik object
                                    stFormClass={"height-field no-arrows mb-0"} // class name for main wrapper
                                    labelName={"Height, in"} // label name
                                    // isRequired={true} // is this field is required or not to show the red star sign
                                    placeholder={"Height, in"} // placeholder for the input
                                    formikFieldName={"blogTitle"} // important: formik value name for the input
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}
